import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import "./Css/CommissionAnalysis.css";

const data = [
  { name: "जानेवारी", value: 200 },
  { name: "फेब्रुवारी", value: 280 },
  { name: "मार्च", value: 620 },
  { name: "एप्रिल", value: 390 },
  { name: "मे", value: 900 },
  { name: "जून", value: 210 },
  { name: "जुलै", value: 560 },
  { name: "ऑगस्ट", value: 740 },
  { name: "सप्टेंबर", value: 560 },
  { name: "ऑक्टोबर", value: 610 },
  { name: "नोव्हेंबर", value: 210 },
  { name: "डिसेंबर", value: 400 },
];

const CommissionAnalysis = () => {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className="commission-wrapper">
      <div className="page-header">
        <h3 style={{ cursor: "pointer" }} onClick={() => navigate(-1)}>
          पुस्तक व्यवस्थापन &gt;&gt; कमिशन आढावा &gt;&gt;
          <span> कमिशन विश्लेषण </span>
        </h3>

        <div className="edit-btnn">
          <button className="btn-outline">प्रिंट ग्राफ</button>
          <button className="primary-btn">रिपोर्ट डाउनलोड करा</button>
        </div>
      </div>

      <h2>कमिशन विश्लेषण</h2>

      <div className="chart-card">
        <ResponsiveContainer width="100%" height={350}>
          <BarChart
            data={data}
            barSize={28}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="name" />
            <YAxis
              domain={[0, 900]}
              ticks={[0, 100, 200, 300, 400, 500, 600, 700, 800, 900]}
            />
            <Tooltip cursor={false} />
            <Bar dataKey="value" radius={[6, 6, 0, 0]}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={activeIndex === index ? "#2563eb" : "#e9ddff"} // blue on hover
                  onMouseEnter={() => setActiveIndex(index)}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default CommissionAnalysis;
